/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';

const useLogError = () => {

  const logError = useCallback((error: any): void => {
    try {
      console.log(error);
    } catch (e: any) {
      console.log(e);
    }
  }, []);

  const extractErrorMessage = useCallback((error: any): string => {
    try {
      if (error?.response?.data) {
        const responseData = error.response.data;
        if (typeof responseData === 'object' && responseData.message) {
          return responseData.message;
        }
        if (typeof responseData === 'string') {
          return responseData;
        }
      }
      if (error?.message) {
        return error.message;
      }
      return 'An unexpected error occurred.';
    } catch (e: any) {
      console.log('Error extracting error message:', e);
      return 'An unexpected error occurred.';
    }
  }, []);

  return { logError, extractErrorMessage };
};

export default useLogError;